<template>
    <div :class="$route.name === 'view-product' ? 'chat-icon chat-icon-mob-position' : 'chat-icon'">
        <div class="services d-flex flex-column gap-2">
            <a v-if="requisites.PHONE_1" :href="`tel:+${requisites.PHONE_1}`"
               class="call position-relative services-link">
                <i class="fa-solid fa-phone"></i>

                <span
                    class="d-block position-absolute p-2 ps-3 shadow bg-dark text-white d-none d-lg-block services-tooltip call-tooltip">
                    Call
                </span>
            </a>

            <!--            <a class="messenger position-relative services-link" href="#" target="_blank">-->
            <!--                <i class="fa-brands fa-facebook-messenger"></i>-->

            <!--                <span-->
            <!--                    class="d-block position-absolute p-2 ps-3 shadow bg-dark text-white d-none d-lg-block services-tooltip messenger-tooltip">Messenger</span>-->
            <!--            </a>-->

            <a v-if="requisites.PHONE_WHATSAPP"
               :href="`https://api.whatsapp.com/send/?phone=${requisites.PHONE_WHATSAPP}&text=Hi&app_absent=0`"
               class="whatsapp position-relative services-link"
               target="_blank">
                <i class="fa-brands fa-whatsapp"></i>

                <span
                    class="d-block position-absolute p-2 ps-3 shadow bg-dark text-white d-none d-lg-block services-tooltip whatsapp-tooltip">WhatsApp</span>
            </a>

            <a v-if="requisites.PHONE_VIBER" :href="`viber://chat/?number=${requisites.PHONE_VIBER}`"
               class="viber position-relative services-link"
               target="_blank">
                <i class="fa-brands fa-viber"></i>

                <span
                    class="d-block position-absolute p-2 ps-3 shadow bg-dark text-white d-none d-lg-block services-tooltip viber-tooltip">Viber</span>
            </a>

            <a v-if="requisites.PHONE_TELEGRAM" :href="`https://t.me/${requisites.PHONE_TELEGRAM}`"
               class="telegram position-relative services-link" target="_blank">
                <i class="fa-brands fa-telegram"></i>

                <span
                    class="d-block position-absolute p-2 ps-3 shadow bg-dark text-white d-none d-lg-block services-tooltip telegram-tooltip">Telegram</span>
            </a>
        </div>

        <a class="chat-open-services text-decoration-none mt-2" @click="chat">
            <i class="fa fa-message d-block" title="Open chat"></i>
            <i class="fa fa-times" title="Close chat"></i>
        </a>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "ChatIconGp",

    computed: {
        ...mapGetters(['availableLocales', 'company', 'locale', 'requisites']),

        currentLocale() {
            return this.locale || window.localStorage.getItem('locale') || 'ka'
        }
    },

    methods: {
        chat() {
            document.querySelector('.chat-open-services').classList.toggle('active')
            if (document.querySelector('.chat-open-services').classList.contains('active')) {
                document.querySelectorAll('.services-link').forEach(node => node.classList.add('d-block'))
                document.querySelector('.chat-open-services .fa-message').classList.add('d-none');
                document.querySelector('.chat-open-services .fa-times').classList.add('d-block');
            } else {
                document.querySelectorAll('.services-link').forEach(node => node.classList.remove('d-block'))
                document.querySelector('.chat-open-services .fa-message').classList.remove('d-none');
                document.querySelector('.chat-open-services .fa-times').classList.remove('d-block');
            }
        }
    },

}
</script>

<style scoped>
.services-tooltip {
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: .3s;
}

.services-tooltip::after {
    content: '';
    background-color: #212529;
    width: 28px;
    height: 28px;
    position: absolute;
    right: -14px;
    top: 50%;
    transform: translateY(-50%) rotate(-45deg);
    z-index: -1;
}

.call-tooltip {
    left: -85px;
}

.messenger-tooltip,
.whatsapp-tooltip {
    left: -135px;
}

.viber-tooltip {
    left: -90px;
}

.telegram-tooltip {
    left: -125px;
}

.services-link:hover .services-tooltip {
    opacity: 1;
}

.chat-icon {
    right: 15px;
    bottom: 15px;
    position: fixed;
    z-index: 1001;
}


.chat-icon a.chat-open-services {
    background-color: #212529;
    color: #fff;
    line-height: 55px;
    border: none;
    cursor: pointer;
    font-size: 23px;
    width: 55px;
    height: 55px;
    text-align: center;
    box-shadow: 2px 2px 8px -3px #000;
    border-radius: 100%;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    -ms-border-radius: 100%;
    display: inline-block;
}

.chat-icon a.chat-open-services i {
    line-height: 55px;
}

.chat-icon a.chat-open-services i.fa-times {
    display: none;
}

.chat-icon .services {
    width: 55px;
    height: auto;
}

.services a {
    display: none;
}

.chat-icon .services a i {
    background-color: #212529;
    color: #fff;
    line-height: 55px;
    /*margin-top: 10px;*/
    border: none;
    cursor: pointer;
    font-size: 26px;
    width: 55px;
    height: 55px;
    text-align: center;
    box-shadow: 2px 2px 8px -3px #000;
    border-radius: 100%;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    -ms-border-radius: 100%;
}


.chat-icon .services a.messenger i {
    background-color: #0084ff;
}

.chat-icon .services a.whatsapp i {
    background-color: #25d366;
}

.chat-icon .services a.viber i {
    background-color: #7360F2;
}

.chat-icon .services a.telegram i {
    background-color: #2AABEE;
}

@media screen and (max-width: 991px) {
    .chat-icon-mob-position {
        bottom: 75px;
    }
}
</style>